import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getDocumentMail } from 'modules/accommodations/features/reservations/api';

export const useCalculationLogMailQuery = (mailId: string) =>
  useQuery([QUERY_KEYS.RENTALS_CALCULATION_MAIL_DETAILS, mailId], () => getDocumentMail(mailId));
